/**
 * LegalTemplates PDF Editor — entry point
 *
 * Vite entry (see vite.config.js). Page config is injected by the Blade view
 * as window.pdfEditorConfig. pdf.js and pdf-lib are bundled from npm through
 * context.js; the pdf.js worker is a module worker in our own build output.
 */
import { boot } from './boot.js';
import { pdfjsLib, pdfWorkerUrl } from './context.js';
import { setStatus, showAlert } from './ui.js';

try {
    pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
    boot();
} catch (error) {
    showAlert('The PDF editor could not start. Refresh and try again.', true);
    setStatus('Editor failed to start');
    throw error;
}
